/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/assets/style/layout.css"

import React from "react"
import { RecaptchaProvider } from "./src/context/recaptchaContext"

export const wrapRootElement = ({ element }) => (
  <RecaptchaProvider>{element}</RecaptchaProvider>
)
